module.exports = __webpack_public_path__ + "static/media/free_info.47fb3ebc.png";